export default __webpack_public_path__ + "static/media/user-plus.8d502b38.svg";